import { activeUserProfile } from '../active-userprofile';
import { canAccessRoute } from './route-access';

/**
 * Whether the signed-in person may open a route right now, by the same rule the router
 * enforces when they try (router.ts, the route-access plugin).
 *
 * WHY THIS EXISTS: a workspace tab may offer a link out to a module's own page, and the
 * workspace routes are staff routes while the module routes need a domain or role not every
 * staff member holds. A link offered to everyone would send some of them to "not allowed",
 * which is worse than no link. The hosts ask here before offering, and because the answer
 * comes from the router's own rules the link and the router can never disagree.
 */
export function viewerCanOpen(path: string): boolean {
  const user = activeUserProfile();
  return canAccessRoute(
    path,
    user?.access,
    !!user && (user.isLoggedIn ?? false)
  ).allowed;
}
